var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBankId(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 184,
    viewBox: "0 0 214 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3676_8320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.8 112C133.31 112 154.8 90.5097 154.8 64C154.8 37.4903 133.31 16 106.8 16C80.2904 16 58.8 37.4903 58.8 64C58.8 90.5097 80.2904 112 106.8 112Z",
    stroke: "#9CBCBF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.8 69.3335C115.637 69.3335 122.8 62.1701 122.8 53.3335C122.8 44.4969 115.637 37.3335 106.8 37.3335C97.9635 37.3335 90.8 44.4969 90.8 53.3335C90.8 62.1701 97.9635 69.3335 106.8 69.3335Z",
    stroke: "#9CBCBF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.696 100.528C77.0161 96.1347 79.7172 92.2838 83.3987 89.5467C87.0802 86.8096 91.5459 85.3321 96.1334 85.3335H117.467C122.06 85.3319 126.531 86.8129 130.215 89.5563C133.9 92.2997 136.6 96.159 137.915 100.56",
    stroke: "#9CBCBF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3676_8320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4429 156.571H2.28857C1.068 156.571 0 155.505 0 154.286C0 153.067 1.068 152 2.28857 152H11.4429C12.6634 152 13.7314 153.067 13.7314 154.286C13.7314 155.505 12.6634 156.571 11.4429 156.571Z",
    fill: "#39134C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4429 174.857H2.28857C1.068 174.857 0 173.79 0 172.571C0 171.352 1.068 170.286 2.28857 170.286H11.4429C12.6634 170.286 13.7314 171.352 13.7314 172.571C13.7314 173.79 12.6634 174.857 11.4429 174.857Z",
    fill: "#39134C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4429 184H2.28857C1.068 184 0 182.933 0 181.714C0 180.495 1.068 179.429 2.28857 179.429H11.4429C12.6634 179.429 13.7314 180.495 13.7314 181.714C13.7314 182.933 12.6634 184 11.4429 184Z",
    fill: "#39134C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7515 165.714H20.5972C19.3766 165.714 18.3086 164.648 18.3086 163.429C18.3086 162.21 19.3766 161.143 20.5972 161.143H29.7515C30.972 161.143 32.04 162.21 32.04 163.429C32.04 164.648 30.972 165.714 29.7515 165.714Z",
    fill: "#39134C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7515 174.857H20.5972C19.3766 174.857 18.3086 173.79 18.3086 172.571C18.3086 171.352 19.3766 170.286 20.5972 170.286H29.7515C30.972 170.286 32.04 171.352 32.04 172.571C32.04 173.79 30.972 174.857 29.7515 174.857Z",
    fill: "#39134C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.06 156.571H38.9058C37.6852 156.571 36.6172 155.505 36.6172 154.286C36.6172 153.067 37.6852 152 38.9058 152H48.06C49.2806 152 50.3486 153.067 50.3486 154.286C50.3486 155.505 49.2806 156.571 48.06 156.571Z",
    fill: "#39134C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.06 165.714H38.9058C37.6852 165.714 36.6172 164.648 36.6172 163.429C36.6172 162.21 37.6852 161.143 38.9058 161.143H48.06C49.2806 161.143 50.3486 162.21 50.3486 163.429C50.3486 164.648 49.2806 165.714 48.06 165.714Z",
    fill: "#39134C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.06 184H38.9058C37.6852 184 36.6172 182.933 36.6172 181.714C36.6172 180.495 37.6852 179.429 38.9058 179.429H48.06C49.2806 179.429 50.3486 180.495 50.3486 181.714C50.3486 182.933 49.2806 184 48.06 184Z",
    fill: "#39134C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8777 171.962C69.8777 176.838 72.624 179.429 75.828 179.429C78.7268 179.429 81.9308 176.99 81.9308 171.962C81.9308 166.933 78.8794 164.648 75.9805 164.648C72.7765 164.648 69.8777 166.933 69.8777 171.962ZM69.8777 152V163.886C71.2508 161.752 73.692 159.619 77.8114 159.619C82.3885 159.619 87.8811 163.429 87.8811 171.81C87.8811 180.495 82.6937 184.762 77.3537 184.762C74.3022 184.762 71.7085 183.39 70.0302 180.648V184H64.08V152H69.8777Z",
    fill: "#39134C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5776 172.114C96.5776 177.143 99.629 179.429 102.528 179.429C105.732 179.429 108.478 177.295 108.478 172.114C108.478 167.086 105.732 164.648 102.528 164.648C99.7816 164.648 96.5776 166.933 96.5776 172.114ZM90.7799 171.81C90.7799 163.581 96.1199 159.467 101.46 159.467C104.359 159.467 106.8 160.533 108.631 163.124V160.076H114.428V184H108.631V180.648C106.952 182.933 104.511 184.61 100.697 184.61C96.1199 184.61 90.7799 180.648 90.7799 171.81Z",
    fill: "#39134C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.871 170.438V184H120.074V160.229H125.871V163.733C127.55 160.686 130.601 159.619 133.195 159.619C137.314 159.619 141.281 161.752 141.281 168.152V184H135.483V170.286C135.483 166.324 133.5 164.8 130.906 164.8C128.007 164.952 125.871 166.629 125.871 170.438Z",
    fill: "#39134C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.774 152V184H152.571V178.21L155.775 174.248L162.336 184H168.744L159.285 170.133L167.523 160.229H160.963L152.571 171.2V152H146.774Z",
    fill: "#39134C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.339 153.067H174.389V184H180.339V153.067Z",
    fill: "#39134C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.58 153.067H186.29V184H197.58C205.971 184 212.99 178.972 212.99 168.457C212.99 158.095 205.971 153.067 197.58 153.067ZM197.58 178.515H192.24V158.553H197.58C202.462 158.553 206.582 161.753 206.582 168.61C206.582 175.315 202.462 178.515 197.58 178.515Z",
    fill: "#39134C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3676_8320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(42.8)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3676_8320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 213.6,
    height: 32,
    fill: "white",
    transform: "translate(0 152)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankId);
export default __webpack_public_path__ + "static/media/bankId.291c8838ea83531fdc667d0b66a669d1.svg";
export { ForwardRef as ReactComponent };